export const separatePhoneIfFormatted = (
  phone: string,
  mappedPhoneCodeToCountryCode: { [p: string]: string[] }
) => {
  const separated = {
    phone,
    code: '',
  }

  // implementation is copied from getSeparatedPhone.ts
  const formattedPhone = separated.phone.replace(/(^[+]?0*)|\D/g, '')
  if (phone === formattedPhone) {
    for (let codeLen = 3; codeLen > 0; codeLen--) {
      const countryPhoneCode = formattedPhone.substring(0, codeLen)
      if (mappedPhoneCodeToCountryCode[countryPhoneCode]) {
        separated.code = countryPhoneCode
        separated.phone = formattedPhone.substring(codeLen)
      }
    }
  }

  return separated
}
